let filtersApplied = ['role--all', 'status--all'];

function updateView() {
    console.log(filtersApplied);

    const filter_buttons = document.querySelectorAll(".filter__button");
    for (var i = 0; i < filter_buttons.length; i++) {
        filter_buttons[i].classList.remove("active");
        if(filtersApplied.includes(filter_buttons[i].dataset.filter)){
            filter_buttons[i].classList.add("active");
        }
    }

    const film_entries = document.querySelectorAll(".filmlist__entry");
    for(var i = 0; i < film_entries.length; i++){
        film_entries[i].classList.remove("hidden");
        let isValid = filtersApplied.every((filter) => {
            return film_entries[i].classList.contains(filter);
        });
        if(!isValid){
            film_entries[i].classList.add("hidden");
        }
    }

    const filter_items_mobile = document.querySelectorAll(".filter--item");
    for (var i = 0; i < filter_items_mobile.length; i++) {
        filter_items_mobile[i].classList.remove("active");
        if (filtersApplied.includes(filter_items_mobile[i].dataset.filter)) {
            filter_items_mobile[i].classList.add("active");
        }
    }

    const filter_buttons_mobile = document.querySelectorAll(".filter__button--mobile");
    for(var i = 0; i < filter_buttons_mobile.length; i++){
        filter_buttons_mobile[i].classList.remove("active");
        if (filtersApplied.includes(filter_items_mobile[i].dataset.filter)) {
            filter_buttons_mobile[i].classList.add("active");
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const filter = document.getElementById("filter");

    if (filter) {

        updateView();

        const filter_buttons = document.querySelectorAll(".filter__button");
        for (var i = 0; i < filter_buttons.length; i++) {
            filter_buttons[i].addEventListener("click", function () {
                const filter = this.dataset.filter;
                if(filter.includes('role--')){
                    filtersApplied = filtersApplied.filter((item) =>
                        !item.includes("role--")
                    );
                } else {
                    filtersApplied = filtersApplied.filter((item) =>
                        !item.includes("status--")
                    );
                }
                filtersApplied.push(filter);

                /*if (filtersApplied.includes(filter)) {
                    filtersApplied = filtersApplied.filter(
                        (item) => item !== filter
                    );
                } else {
                    filtersApplied.push(filter);
                }*/
                updateView();
            });
        }

        const filter_mobile_buttons = document.querySelectorAll(".filter__button--mobile");
        for (var i = 0; i < filter_mobile_buttons.length; i++) {
            filter_mobile_buttons[i].addEventListener("click", function () {
                const filter = this.dataset.filter;

                if (filter.includes("role--")) {
                    filtersApplied = filtersApplied.filter(
                        (item) => !item.includes("role--")
                    );
                } else {
                    filtersApplied = filtersApplied.filter(
                        (item) => !item.includes("status--")
                    );
                }

                if (!this.classList.contains("active")) {
                    filtersApplied.push(filter);
                } else {
                    if (filter.includes("role--")) {
                        filtersApplied.push("role--all");
                    }
                    if (filter.includes("status--")) {
                        filtersApplied.push("status--all");
                    }
                }

                /*if (filtersApplied.includes(filter)) {
                    filtersApplied = filtersApplied.filter(
                        (item) => item !== filter
                    );
                } else {
                    filtersApplied.push(filter);
                }*/
                updateView();
            });
        }

        const filter_mobile_items = document.querySelectorAll(".filter--item");
        for (var i = 0; i < filter_mobile_items.length; i++) {
            filter_mobile_items[i].addEventListener("click", function () {
                const filter = this.dataset.filter;

                if (filter.includes("role--")) {
                    filtersApplied = filtersApplied.filter(
                        (item) => !item.includes("role--")
                    );
                } else {
                    filtersApplied = filtersApplied.filter(
                        (item) => !item.includes("status--")
                    );
                }

                if (!this.classList.contains("active")) {
                    filtersApplied.push(filter);
                } else {
                    if (filter.includes("role--")) {
                        filtersApplied.push("role--all");
                    }
                    if (filter.includes("status--")) {
                        filtersApplied.push("status--all");
                    }
                }

                /*if (filtersApplied.includes(filter)) {
                    filtersApplied = filtersApplied.filter(
                        (item) => item !== filter
                    );
                } else {
                    filtersApplied.push(filter);
                }*/
                updateView();
            });
        }


        const mobilefilter_overlay = document.getElementById("js-filter__mobile__overlay");

        const mobilefilter_button = document.getElementById("js-filter__mobile__button");
        if(mobilefilter_button){
            mobilefilter_button.addEventListener("click", function () {
                mobilefilter_overlay.classList.toggle("active");
            });
        }

        const mobilefilter_overlay_close = document.getElementById("js-mobile-filter__close");
        if(mobilefilter_overlay_close){
            mobilefilter_overlay_close.addEventListener("click", function () {
                mobilefilter_overlay.classList.toggle("active");
            });
        }

        const mobilefilter_overlay_close_button = document.getElementById('js-filter__showbutton');
        if(mobilefilter_overlay_close_button){
            mobilefilter_overlay_close_button.addEventListener("click", function () {
                mobilefilter_overlay.classList.toggle("active");
            });
        }

    }
});
